<template>
  <b-modal id="bundleCancelModal" :title="title" size="lg" @show="onShow">
    <!-- <div class="flex items-center justify-between mb20">
      <div>
        <p>묶음배송할 처방을 선택해주세요.</p>
        <strong style="color: red" class="fwb text-xs"
          >* 탕전처방, 약속탕전, 약속처방 서로 다른 제형은 묶음신청이
          불가능합니다.</strong
        >
      </div>
    </div> -->
    <div class="search user_modal">
      <div
        class="table_list mb30"
        style="
          max-height: 480px;
          height: 480px;
          overflow: hidden;
          overflow-y: auto;
        "
      >
        <table class="list no_view text-sm">
          <colgroup>
            <col width="150" />
            <col width="50" />
            <col width="100" />
            <col width="100" />
            <col width="100" />
            <col width="200" />
            <col width="100" />
            <col width="200" />
            <col width="100" />
          </colgroup>
          <thead>
            <tr>
              <th>주문번호</th>
              <th>분류</th>
              <th>환자명</th>
              <th>처방명</th>
              <th>보내는사람</th>
              <th>보내는주소</th>
              <th>받는사람</th>
              <th>받는주소</th>
              <th>배송비</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item  , index) in combineList" :key="index">
              <!-- <td>
                <div v-if="item.is_combined == 'Y'" class="flex jc">
                  <b-badge variant="success">
                    묶음
                  </b-badge>
                </div>
                <div class="form_checkbox" v-else style="min-width: auto">
                  <input
                    type="checkbox"
                    :id="'deliveryCheckbox' + index"
                    name="checkbox"
                    :value="item.prescribe_seq"
                    v-model="checkedSeqs"
                    @change="fn_check_change(item.is_combined)"
                  />
                  <label :for="'deliveryCheckbox' + index" class="jc"></label>
                </div>
              </td> -->
              <td>
                <span>{{ item.prescribe_seq }}</span>
              </td>
              <td>
                <span v-if="item.prescribe_type == 'T'" class="font_orange">탕전</span>
                <span v-if="item.prescribe_type == 'I'" class="font_green">첩약</span>
                <span v-if="item.prescribe_type == 'P'" class="font_blue">약속</span>
              </td>
              <td>
                <span>{{ item.patient_nm }}</span>
              </td>
              <td class="al">
                <span>{{ item.prescribe_nm }}</span>
              </td>
              <td>
                <span>{{ item.send_nm }}</span>
              </td>
              <td>
                <span>{{ item.send_addr  }} {{ item.send_addr_dtl  }}</span>
              </td>
              <td>
                <span>{{ item.receive_nm }}</span>
              </td>
              <td>
                <span>{{ item.receive_addr  }} {{ item.receiveaddr_dtl  }}</span>
              </td>
              <td>
                <span>{{ fn_comma_won(item.total_delivery_price) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr />
    <div class="flex items-center jc gap8">
      <!-- <p class="text-sm fwb">묶음배송주소</p> -->
      <!-- <div class="form_select">
        <b-form-select v-model="combineMainOrder">
          <b-form-select-option value="">
            메인 주문을 선택해주세요.
          </b-form-select-option>
          <b-form-select-option v-for="(item, index) in checkList" :key="index" :value="item.prescribe_seq">{{item.prescribe_seq}}</b-form-select-option>
        </b-form-select>
      </div> -->
      <button class="btn btn_md btn_deepbrown" @click="fn_combine_cancel_delivery" >
        묶음취소하기
      </button>
    </div>
    <template #modal-footer>
      <div></div>
    </template>

    <alert-modal 
      :id="'alert'"
      :text="showAlertMsg" 
      :btnRight="'확인'" 
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="false"
      v-on:update:showSetting="fn_showSet"
    />
  </b-modal>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  name: "writeModal",
  props: {
    title: String,
    combinePrescribe : Number
  },
  components: {
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {

      combineList : [],

    };
  },
  mounted() {

  },
  methods: {
    onShow() {
      //모달창이 열릴때마다
      //묵음 정보를 가져온다.
      // let itemList= this.list.map(item => item.seq)

      console.log("@@@@@ onshow bundleCancelModal :  %o",this.combinePrescribe);
      let param = new Object();
      param.combinePrescribe = this.combinePrescribe;

      axios
        .post("/api/user/mypage/getCombineList", param)
        .then((res) => {
            console.log("@@@@ res : %o",res);
            this.combineList = res.data.combineList;
                   

        })
        .catch((err) => console.log(err));
      
    },
 
    fn_combine_cancel_delivery(){

      let param = new Object();
      param.mainPrescribe = this.combinePrescribe;

      axios
        .post("/api/user/mypage/cancelCombined", param)
        .then((res) => {
            
            // 묶음 취소 정보 부모창 갱신
            this.$emit('cancel-combine');

        })
        .catch((err) => console.log(err));

    }
  },
};
</script>

<style scoped>
.custom-select {
  width: 500px;
}
</style>
